import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Backdrop, CircularProgress, InputAdornment } from '@mui/material';
import api from "../../services/api";
import { login, SetUser } from "../../services/auth";
import { decrypt, encrypt, GeneratePassword } from '../../crypto/crypto';
import moment from 'moment';
const LOGO_URL = 'http://www.ijobtech.com/images/ijoblogo02.png'
const LOGO2_URL = 'http://www.ijobtech.com/images/ijoblogo03.png'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Colors } from '../../constants/Colors';
import { PasswordStrength } from '../../utils/StringUtils';
import { isMobile } from '../../utils/isMobile';
import { RedefinirSenhaWebAPI } from '../../services/User';
function Copyright ()
{
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      { 'Copyright © ' }
      <Link color="inherit" href="https://material-ui.com/">
        iJob
      </Link>{ ' ' }
      { new Date().getFullYear() }
      { '.' }
    </Typography>
  );
}

const useStyles = makeStyles( ( theme ) => ( {
  root: {
    height: '100vh',
    backgroundColor: '#fff'
  },
  image: {
    backgroundImage: `url(${ LOGO_URL })`,
    backgroundRepeat: 'no-repeat',

    backgroundSize: 'contain',
    backgroundPosition: 'center',

  },
  paper: {
    margin: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: 1,
    backgroundColor: Colors.LightGray,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: 3,
  },
  Backdrop: { zIndex: 1, color: '#fff' }
} ) );

export default function ForgotPassword ( props )
{

  const ROUTE_PARAMS_ARRAY = decrypt( props.history.location.pathname.replace( '/ForgotPassword:', '' ) ).split( '|' )
  const USER_ID = ROUTE_PARAMS_ARRAY[ 0 ]
  const USER_REQUEST_DATE = ROUTE_PARAMS_ARRAY[ 1 ]

  const classes = useStyles();

  const [ ConfirmPassword, setConfirmPassword ] = React.useState( '' )
  const [ ConfirmPasswordValid, setConfirmPasswordValid ] = React.useState( false )

  const [ Password, setPassword ] = useState( '' )
  const [ PasswordValid, setPasswordValid ] = useState( false )

  const [ IsTimeValid, setIsTimeValid ] = useState( null )

  const [ ShouldDisableButton, setShouldDisableButton ] = useState( true )

  const [ RequestSuccess, setRequestSuccess ] = useState( null )

  const [ state, setState ] = React.useState( { open: false, vertical: 'top', horizontal: 'center', } )
  const [ SnackMessage, setSnackMessage ] = React.useState( '' )
  const { vertical, horizontal, open } = state
  const [ openBackground, setOpenBackground ] = React.useState( false );

  const DynamicInputs = [
    {
      variant: 'outlined'
      , margin: 'normal'
      , required: true
      , fullWidth: true
      , id: 'password'
      , label: "Senha"
      , name: "password"
      , autoFocus: true
      , autoComplete: "current-password"
      , type: 'password'
      , value: Password
      , onChange: setPassword
      , isValid: PasswordValid
    },
    {
      variant: 'outlined'
      , margin: 'normal'
      , required: true
      , fullWidth: true
      , id: 'Confirmpassword'
      , label: "Confirmar Senha"
      , name: "Confirmpassword"
      , autoFocus: false
      , autoComplete: "current-password"
      , type: 'password'
      , value: ConfirmPassword
      , onChange: setConfirmPassword
      , isValid: ConfirmPasswordValid
    },
  ]

  useEffect( () =>
  {
    Mount()
  }, [] )

  useEffect( () =>
  {
    if ( Password.length > 0 )
    {
      if ( PasswordStrength( Password ).id >= 1 )
        setPasswordValid( true )
      else
        setPasswordValid( false )
    }
  }, [ Password ] )

  useEffect( () =>
  {
    if ( Password === ConfirmPassword && PasswordValid )
      setConfirmPasswordValid( true )
    else
      setConfirmPasswordValid( false )
  }, [ Password, ConfirmPassword, PasswordValid ] )

  useEffect( () =>
  {
    if ( ConfirmPasswordValid && PasswordValid && IsTimeValid )
    {
      setShouldDisableButton( false )
    }
    else
    {
      setShouldDisableButton( true )

    }

  }, [ ConfirmPasswordValid, PasswordValid, IsTimeValid ] )

  async function Mount ()
  {
    let diff = moment.utc().valueOf() - ( moment.utc( USER_REQUEST_DATE ).valueOf() );
    let Minutes = moment.duration( diff ).asMinutes()

    if ( Minutes > 3 )
      setIsTimeValid( false )
    else
      setIsTimeValid( true )
  }

  async function handleSubmit ( e )
  {
    e.preventDefault();

    if ( !ShouldDisableButton )
    {
      const response = await RedefinirSenhaWebAPI( encrypt( USER_ID ), GeneratePassword( Password ) )

      if ( response !== undefined )
      {
        if ( response.Sucesso )
        {
          setRequestSuccess( true )
        }
        else
        {
          setRequestSuccess( false )
        }
      }
    }
  }

  return (
    <Grid container component="main" className={ classes.root }>
      <CssBaseline />

      <div style={ { display: 'flex', flex: 1, justifyContent: 'center', backgroundImage: `url(${ 'https://i.imgur.com/GH6qE9N.jpg' })` } }>
        <Grid item xs={ false } sm={ 4 } md={ 7 } className={ classes.image } />
      </div>

      <Grid
        item xs={ 12 }
        sm={ 8 }
        md={ 5 }
        component={ Paper }
        elevation={ 6 }
        square>
        <div style={ { backgroundColor: Colors.Primary, flex: 1, display: 'flex', alignItems: 'center', minHeight: '25%', justifyContent: 'center' } }>
          <img
            src={ LOGO2_URL }
            style={ { resizeMode: 'cover', height: 'auto', width: '50%', backgroundColor: Colors.Primary, padding: 15, borderRadius: 5 } } />
        </div>
        <div className={ classes.paper }>
          <Typography component="h1" variant="h5">Redefinição de senha</Typography>
          {
            !IsTimeValid &&
            <Typography
              component="h1"
              variant="h5"
              style={ { color: Colors.ErroRed, marginTop: 10, marginBottom: 5, textAlign: 'center' } }
            >Tempo para redefinição esgotado, peça novamente a redefinição por e-mail dentro do app.</Typography>
          }
          {
            RequestSuccess !== null && RequestSuccess ?
              <Typography
                component="h1"
                variant="h5"
                style={ { color: Colors.GoodGreen, marginTop: 10, marginBottom: 5, textAlign: 'center' } }
              >Senha redefinida com sucesso.</Typography> :
              RequestSuccess === false &&
              <Typography
                component="h1"
                variant="h5"
                style={ { color: Colors.ErroRed, marginTop: 10, marginBottom: 5, textAlign: 'center' } }
              >Ocorreu um erro ao atualizar a senha.</Typography>
          }
          {
            !RequestSuccess && IsTimeValid &&

            <form className={ classes.form } noValidate onSubmit={ handleSubmit }>
              {
                DynamicInputs.map( item =>
                  <div key={ item.id } style={ { flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' } }>
                    <TextField
                      variant={ item.variant }
                      margin={ item.margin }
                      required={ item.required }
                      fullWidth={ item.fullWidth }
                      id={ item.id }
                      label={ item.label }
                      name={ item.name }
                      autoComplete={ item.autoComplete }
                      autoFocus={ item.autoFocus }
                      type={ item.type }
                      InputProps={ {
                        endAdornment: <div style={ { flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' } }>

                          {
                            !isMobile && item.value.length <= 6 &&
                            <InputAdornment position="end">A senha deve ter no mínimo 6 caracteres</InputAdornment>
                          }

                          {
                            item.isValid
                              ? <CheckCircleOutlineIcon style={ { color: Colors.Primary, marginLeft: 5, fontSize: 30 } } />
                              : <ErrorOutlineIcon style={ { color: Colors.ErroRed, marginLeft: 5, fontSize: 30 } } />
                          }
                        </div>
                      } }
                      onChange={ e => { item.onChange( e.target.value ) } }
                    />


                  </div>
                )
              }

              <Button
                disabled={ ShouldDisableButton }
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={ classes.submit }>Confirmar alteração</Button>

              <Box mt={ 5 }>
                <Copyright />
              </Box>
            </form>
          }
          <Backdrop
            className={ classes.Backdrop }
            open={ openBackground }>
            <CircularProgress color="inherit" />
          </Backdrop>

        </div>
      </Grid>
    </Grid>
  );
}

